import { render, staticRenderFns } from "./RefundExtraData.vue?vue&type=template&id=6d066a7b&"
import script from "./RefundExtraData.vue?vue&type=script&lang=js&"
export * from "./RefundExtraData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports